import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If your Next.js app uses the `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/app"
      }}>{`app router`}</a>{`, you can integrate PostHog by creating a `}<inlineCode parentName="p">{`providers`}</inlineCode>{` file in your app folder. This is because the `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` library needs to be initialized on the client-side using the Next.js `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/app/getting-started/server-and-client-components"
      }}><inlineCode parentName="a">{`'use client'`}</inlineCode>{` directive`}</a>{`.`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`// app/providers.jsx
'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export function PostHogProvider({ children }) {
  useEffect(() => {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      defaults: '<ph_posthog_js_defaults>',
    })
  }, [])

  return (
    <PHProvider client={posthog}>
      {children}
    </PHProvider>
  )
}
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-tsx"
        }}>{`// app/providers.tsx
'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
    useEffect(() => {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
        defaults: '<ph_posthog_js_defaults>',
      })
  }, [])

  return (
    <PHProvider client={posthog}>
      {children}
    </PHProvider>
  )
}
`}</code></pre>
    </MultiLanguage>
    <p>{`Then, import the `}<inlineCode parentName="p">{`PostHogProvider`}</inlineCode>{` component into your `}<inlineCode parentName="p">{`app/layout`}</inlineCode>{` file and wrap your app with it.`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`// app/layout.jsx

import './globals.css'
import { PostHogProvider } from './providers'

export default function RootLayout({ children }) {
  return (
    <html lang="en">
      <body>
        <PostHogProvider>
          {children}
        </PostHogProvider>
      </body>
    </html>
  )
}
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-tsx"
        }}>{`// app/layout.tsx

import './globals.css'
import { PostHogProvider } from './providers'

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <body>
        <PostHogProvider>
          {children}
        </PostHogProvider>
      </body>
    </html>
  )
}
`}</code></pre>
    </MultiLanguage>
    <p>{`PostHog is now set up and ready to go. It will begin to autocapture events and pageviews. Files and components accessing PostHog on the client-side need the `}<inlineCode parentName="p">{`'use client'`}</inlineCode>{` directive.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      